export const naturalNumbers = {
  mask: Number,
  scale: 0,
  signed: false,
  min: 0,
  thousandsSeparator: ' ',
  unmask: 'typed'
}
